import { CALL_API } from '@aftonbladet/redux-api-middleware';
import { appConfig as config } from 'roc-package-web-app-react/app/shared/universal-config';

export default function getTagByTitle({ force = false, title }) {
    const {
        iris: { host },
    } = config;

    const endpoint = `${host}/v1/tagLookup?title=${title}`;

    return {
        [CALL_API]: {
            endpoint,
            method: 'GET',
            types: [
                'GET_TAG_BY_TITLE_REQUEST',
                'GET_TAG_BY_TITLE_SUCCESS',
                'GET_TAG_BY_TITLE_FAILURE',
            ],
            bailout: () => !force,
        },
    };
}



/** WEBPACK FOOTER **
 ** ./src/redux/actions/get-tag-by-title.js
 **/